// extracted by mini-css-extract-plugin
export default {"subItemsRow":"PriceFormSubItem_subItemsRow__ouWaq","valueColumn":"PriceFormSubItem_valueColumn__lYwTc","subCommonStyle":"PriceFormSubItem_subCommonStyle__-jDf9 body--l"};